// extracted by mini-css-extract-plugin
export var actions = "_rw-5";
export var assistantBubble = "_rw-3";
export var assistantRow = "_rw-6";
export var bubble = "_rw-0";
export var humanAvatar = "_rw-4";
export var inlineToolCard = "_rw-1";
export var userBubble = "_rw-2";